import { render, staticRenderFns } from "./AddChatPopup.vue?vue&type=template&id=635e8ace&scoped=true"
import script from "./AddChatPopup.vue?vue&type=script&lang=js"
export * from "./AddChatPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635e8ace",
  null
  
)

export default component.exports